import { Button } from "@/components/ui/button";
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  return (
    <div className="relative h-[70vh] bg-[#ea384c]">
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-transparent" />
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
        <div className="text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Welcome to ReyanSH Kitchen
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-2xl">
            Experience authentic flavors delivered right to your doorstep
          </p>
          <Button size="lg" className="bg-white text-[#ea384c] hover:bg-white/90">
            Order Now <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;